export const DEFAULT_USER_AVATAR =
  'http://cf.ltkcdn.net/socialnetworking/images/std/168646-425x425-Cat-Avatar-Primary.jpg';

export const EDITOR_ITEMS = {
  SCENE: 'scene',
  LAYER: 'layer',
  WIDGET: 'widget',
  MAP_WIDGET: 'map_widget',
};

export const WIDGETS = {
  PORTAL: 'portal',
  SOUND: 'sound',
  INFO_WINDOW: 'info_window',
  GALLERY: 'gallery',
  MAP: 'map',
  TEXT: 'text',
  INSTANCE: 'instance',
};

export const HISTORY_RECORDS = {
  PROJECTS: 'projects',
};

export const OPERATION_TYPES = {
  CREATE: 'create',
  UPDATE: 'update',
};

export const IMAGE_SIZES = {
  THUMB_64: 'thumb_64',
  THUMB_256: 'thumb_256',
  THUMB_512: 'thumb_512',
  THUMB_1028: 'thumb_1028',
};



// WEBPACK FOOTER //
// ./src/constants.js